<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.REP_Title"
            placeholder="名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.REP_Checkfield">
            <el-option label="--请选择状态--" :value="-1" key="-1"></el-option>
            <el-option label="下线" :value="0" key="0"></el-option>
            <el-option label="上线" :value="1" key="1"></el-option>
            <!-- <el-option label="审核未通过" :value="2" key="2"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="REP_Title" label="名称"></el-table-column>
      <el-table-column prop="" label="是否卓悦会" width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.REP_Source == 1">是</el-tag>
          <el-tag type="warning" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="REP_DownLoadCount"
        label="下载量"
        width="100"
      ></el-table-column>
      <el-table-column prop="" label="状态" width="100"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.REP_Checkfield == 1"
            >上线</el-tag
          >
          <!-- <el-tag type="info" v-else-if="scope.row.REP_Checkfield == 2"
            >审核未通过</el-tag
          > -->
          <el-tag type="danger" v-else>下线</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="REP_Puldate"
        label="发布时间"
        width="180"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="200"
        v-if="tableButtonList.length > 0"
      >
        <template slot-scope="scope">
          <span
            style="padding-left: 10px"
            v-for="item in tableButtonList"
            v-bind:key="item.id"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 新增编辑 -->
    <el-dialog
      title="新增/编辑"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <el-form-item prop="REP_Title" label="名称">
          <el-input
            placeholder="名称"
            v-model="ruleForm.REP_Title"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="SolutionGenreIDStr">
          <el-radio-group v-model="ruleForm.SolutionGenreIDStr">
            <el-radio
              v-for="item in SolutionGenreList"
              :key="item.SolutionGenreIDStr"
              :label="item.SolutionGenreIDStr"
              >{{ item.SG_SolutionName }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型" prop="REP_Type">
          <el-radio-group v-model="ruleForm.REP_Type">
            <el-radio :label="0">调研报告</el-radio>
            <el-radio :label="1">文稿</el-radio>
            <el-radio :label="2">工具</el-radio>
            <el-radio :label="3">模板</el-radio>
            <el-radio :label="4">宣传文档</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否卓悦会" prop="REP_Source">
          <el-radio-group v-model="ruleForm.REP_Source">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="REP_Desc" label="内容">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="内容"
            v-model="ruleForm.REP_Desc"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="REP_Pic" label="封面图片">
          <div style="display: flex; align-items: center">
            <div v-if="ruleForm.REP_Pic">
              <img
                class="picImg"
                :src="
                  ruleForm.REP_Pic +
                  '?x-oss-process=image/resize,h_160,w_130,m_fixed'
                "
              />
            </div>
            <div class="editor-custom-btn-container" style="margin-left: 30px">
              <UploadPan
                ref="upload"
                v-model="fileList"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload"
                @on-update="handleOnUpdate"
                :accept="accept"
                color="#1890ff"
              />
              <span style="font-size: 12px">图片尺寸：260*320（宽*高）</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="REP_Accessory" label="上传报告文件">
          <div style="display: flex; align-items: center">
            <div class="" v-if="ruleForm.REP_Accessory">
              <el-link
                :href="ruleForm.REP_Accessory"
                :disabled="!ruleForm.REP_Accessory"
                target="_blank"
                type="primary"
                ><i class="el-icon-view el-icon--right"></i>
              </el-link>
            </div>
            <div class="editor-custom-btn-container" style="margin-left: 30px">
              <UploadPan
                ref="upload2"
                v-model="fileList2"
                :form="form"
                class="editor-upload-btn"
                :model="model"
                @on-close="handleCloseUpload2"
                @on-update="handleOnUpdate2"
                :accept="accept2"
                color="#1890ff"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import clip from '../../../util/clipboard'
import VuePdf from 'vue-pdf'
import UploadPan from '@/components/Upload/index'
import {
  getResearchReportPageList,
  getResearchReportInfo,
  addOrUpdResearchReport,
  getSolutionGenreList,
  offlineResearchReport,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { filterSize } from '../../../util'
import store from '@/store'

export default {
  data() {
    return {
      fileList: [],
      fileList2: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
      accept2: '.PDF,.DOC,.DOCX,.pdf,.doc,.docx',
      BaseTagList: [],
      SolutionGenreList: [],
      listLoading: false,
      topButtonList: [],
      tableButtonList: [],
      editLoading: false,
      filters: {
        REP_Title: '',
        REP_Checkfield: -1,
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      addFormVisible: false, // 新增弹框
      // 新增弹窗数据
      ruleForm: {
        REP_Title: '',
        ReportIDStr: '',
        SolutionGenreIDStr: '',
        REP_Type: -1,
        REP_Source: -1,
        REP_Desc: '',
        REP_FileFix: '',
        REP_FileSize: '',
        REP_Pic: '',
        REP_Accessory: '',
        BEP_TotalPageCount: 0,
        Tags: [],
      },
      rules: {
        REP_Title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        SolutionGenreIDStr: [
          { required: true, message: '请选择分类', trigger: 'blur' },
        ],
        REP_Type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        REP_Source: [
          { required: true, message: '请选择是否卓悦会', trigger: 'blur' },
        ],
        REP_Desc: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        REP_Pic: [{ required: true, message: '请上传封面', trigger: 'blur' }],
        REP_Accessory: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ],
      }, 
    }
  },
  components: {
    UploadPan,
    VuePdf,
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 新增客户用户
    handleAdd() {
      this.addOrUpd()
    },

    handleEdit() {
      getResearchReportInfo(this.currentRow.ReportIDStr).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
        }
      })
      this.addOrUpd()
    },
    // 提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdResearchReport(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$refs[formName].resetFields()
              this.addFormVisible = false
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },
    handleClose(formName) {
      this.addFormVisible = false
      this.$refs.ruleForm.resetFields()
      this.ruleForm.BEP_TotalPageCount = 0
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getResearchReportPageList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handleOffline() {
      this.$confirm('此操作将下线该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          offlineResearchReport(this.currentRow.ReportIDStr).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleCloseUpload() {
      this.fileList = []
    },
    handleOnUpdate(obj) {
      console.log('handleOnUpdate')
      console.log(obj)
      // ?x-oss-process=image/resize,h_160,w_130,m_fixed
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.REP_Pic = url
    },

    handleCloseUpload2() {
      this.fileList2 = []
    },
    handleOnUpdate2(obj) {
      this.ruleForm.REP_FileSize = filterSize(obj.ContentLength)
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      this.ruleForm.REP_Accessory = url
      this.ruleForm.REP_FileFix = obj.ResTitle.split('.').pop()
      this.ruleForm.BEP_TotalPageCount = 0
      if (obj.ContentType.indexOf('pdf')) {
        this.getNumPages(url)
      }
    },

    getNumPages(url) {
      url = url.replace('http:', 'https:')
      let loadingTask = VuePdf.createLoadingTask(url)
      loadingTask.promise
        .then((pdf) => {
          this.ruleForm.BEP_TotalPageCount = pdf.numPages
        })
        .catch((err) => {
          console.error('pdf 加载失败', err)
        })
    },
    addOrUpd() {
      getSolutionGenreList().then((res) => {
        if (res.data.success) {
          this.SolutionGenreList = res.data.response
        }
      })

      this.addFormVisible = true
    },
    copyFormCode(row, event) {
      console.log(row)
      clip(`https://www.hrmarket.net/form_${row.ReportIDStr}.hr`, event)
    },

    // 下载记录
    handleDown(){
      store.commit('saveReportIDStr', this.currentRow.ReportIDStr)
      this.$router.push(`/Consult/ReportRecordList`)
    },
  },
  mounted() {
    this.handleQuery()

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.el-radio-button__inner,
.el-radio-group {
  line-height: 30px;
}

.editor-upload-btn {
  z-index: 3000 !important;
}
.picImg {
  width: 130px;
  height: 160px;
  background-color: red;
  border: 1px solid grey;
}
</style>
